function TableHeader() {
  return (
    <tr className="protocol__table-header">
      <td>Α/Α Αίτησης Ημερομηνία</td>
      <td>Αριθμός Ονομαστικού</td>
      <td>Serial Number</td>
      <td>Ονομασία Υλικού</td>
      <td>Τύπος Οχήματος</td>
      <td>Ποσότητα</td>
      <td>ΗΜ/ΝΙΑ-ΔΙΑΤΑΚΤΙΚΗ</td>
      <td>Χορηγήσεις</td>
      <td>Αριθμός Εργασίας</td>
      <td>ΗΜ/ΝΙΑ-ΕΞΟΔΟΥ</td>
    </tr>
  );
}

export default TableHeader;
